const gsap = window.gsap;

if (gsap !== undefined) {
  gsap.utils.toArray(".header").forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      start: "top bottom",
      end: "bottom top",
      scrub: true,
      onUpdate: (self) => {
        const y = (self.progress - 0.5) * 300;
        gsap.set(el, { "--y": y + "px" });
      },
    });
  });

  // gsap.to(".header_image .header-img", {
  //   yPercent: 10,
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".header",
  //     start: "top bottom",
  //     end: "bottom top",
  //     scrub: true,
  //   },
  // });
}
